/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerChatRequest
 */
export interface PlannerChatRequest {
    /**
     * 
     * @type {string}
     * @memberof PlannerChatRequest
     */
    sessionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerChatRequest
     */
    message: string;
}

/**
 * Check if a given object implements the PlannerChatRequest interface.
 */
export function instanceOfPlannerChatRequest(value: object): value is PlannerChatRequest {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function PlannerChatRequestFromJSON(json: any): PlannerChatRequest {
    return PlannerChatRequestFromJSONTyped(json, false);
}

export function PlannerChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerChatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['session_id'] == null ? undefined : json['session_id'],
        'message': json['message'],
    };
}

export function PlannerChatRequestToJSON(json: any): PlannerChatRequest {
    return PlannerChatRequestToJSONTyped(json, false);
}

export function PlannerChatRequestToJSONTyped(value?: PlannerChatRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_id': value['sessionId'],
        'message': value['message'],
    };
}

